import React, { Fragment } from "react"
import clsx from "clsx"
import { useLocation } from "react-router-dom"

import CheckoutKeypad from "./CheckoutKeypad"
import CheckoutPaymentListCard from "./CheckoutPaymentListCard"
import CheckoutPaymentListHeader from "./CheckoutPaymentListHeader"
import CheckoutPaymentListFooter from "./CheckoutPaymentListFooter"
import { onlyPositiveNumber } from "utils"
import classes from "./index.module.scss"

const CheckoutPaymentList = props => {
  const {
    total,
    isLinkPay,
    cashTypes,
    setCashTypes,
    focusedCashType,
    setFocusedCashType,
    paymentScrollRef
  } = props

  const location = useLocation()

  const handleChange = value => {
    setCashTypes(prev => {
      const notExists = !prev[focusedCashType]
      if (notExists) return prev

      const residue =
        onlyPositiveNumber(
          total - Number(value)
        )

      const result =
        prev.map((cashType, cIndex) =>
          cIndex === focusedCashType
            ?
            {
              ...cashType,
              amount: value
            }
            :
            {
              ...cashType,
              amount: residue !== 0 ? Number(residue).toFixed(2) : 0
            }
        )

      return result
    })
  }

  const amount =
    cashTypes[focusedCashType]?.amount || 0

  const disabled =
    location.state?.mode === "placeOrder"

  return (
    <Fragment>
      <div
        className={
          clsx(
            classes["paymentMethods"],
            disabled && classes["disabled"]
          )
        }
      >
        <CheckoutPaymentListHeader
          total={total}
        />
        <div ref={paymentScrollRef}>
          {cashTypes.map((cashType, cIndex) =>
            <CheckoutPaymentListCard
              key={cIndex}
              total={total}
              cIndex={cIndex}
              cashType={cashType}
              setCashTypes={setCashTypes}
              isLinkPay={isLinkPay}
              focusedCashType={focusedCashType}
              setFocusedCashType={setFocusedCashType}
            />
          )}
          <CheckoutPaymentListFooter
            total={total}
            cashTypes={cashTypes}
          />
        </div>
      </div>

      <CheckoutKeypad
        value={amount}
        isLinkPay={isLinkPay}
        disabled={disabled}
        onChange={handleChange}
        focusedCashType={focusedCashType}
      />
    </Fragment >
  )
}

export default React.memo(CheckoutPaymentList)